import { LookupsService, LookupsProvider, HttpService } from '@lk/api'

export const makeLookupsService = (http: HttpService, baseUrl: string) =>
  new LookupsService(new LookupsProvider(http, baseUrl))
